export const RASTRO_FEATURE = 'rastro';
